import { Button, Classes, Menu, MenuItem, OverflowList, Popover } from "@blueprintjs/core";
import React from "react";
import { connect, DispatchProp } from "react-redux";

import Link from "common/views/pageLink/Link";
import Label from "core/components/label/Label";
import { clearBreadcrumbs } from 'core/actions/paramsActions';
import { IPanelProps, Panel } from "core/decorators/Panel";
import initialState from "core/reducers/initialState";
import { IBreadcrumb } from "core/util/IBreadcrumb";
import BreadcrumbsPanelConfig from "./BreadcrumbsPanelConfig";


interface IBreadcrumbStateProps {
	breadcrumbs: IBreadcrumb[];
	config: {
		label: string;
		showOnlyBack: boolean
	};
}

function mapStateToProps(state: typeof initialState) {
	return { 
		breadcrumbs: state.params.breadcrumbs || [],
	};
}


class BreadcrumbsComponent extends React.Component<IBreadcrumbStateProps & DispatchProp> {

	componentWillUnmount(): void {
		this.props.dispatch(clearBreadcrumbs());
	}

	public render() {
		const { breadcrumbs, config} = this.props;

		if (breadcrumbs.length < 2) {
		  return null;
		}

		if (config.showOnlyBack) { // show only back link if showOnlyBack is enabled
		  const item: IBreadcrumb = {
			key: 'BackButton',
			  label: config.label || 'Back',
			target: {
			  ...breadcrumbs[breadcrumbs.length-2].target
			}
		  }
		  return (
				<Link target={item.target} breadcrumbs={(target, breadcrumbs)=>{
					return ([
						...breadcrumbs.slice(0, breadcrumbs.length - 1),
					])
				}} className={Classes.BREADCRUMB}>
					{this.renderLabel(item)}
				</Link>
			)
		}

		return (
			<OverflowList
				className={Classes.BREADCRUMBS}
				items={breadcrumbs}
				overflowRenderer={this.renderOverflow}
				visibleItemRenderer={this.renderVisibleItem}
			/>
		);
	}

	private renderOverflow = (items: IBreadcrumb[]) => {
		const { breadcrumbs } = this.props;

		return (
			<Popover
				content={
					<Menu>
						{items.map((item, index) => {

							if (index >= breadcrumbs.length - 1) {
								return (
									<MenuItem key={item.key} text={this.renderLabel(item)} disabled={true} />
								);
							}

							return (
								<Link
									key={item.key}
									target={item.target}
									breadcrumbs={this.sliceBreadcrumbs(index)}
									className={Classes.MENU_ITEM}
								>
									{this.renderLabel(item)}
								</Link>
							);
						})}
					</Menu>
				}
			>
				<Button icon="more" minimal={true} />
			</Popover>
		);
	}

	private renderVisibleItem = (item: IBreadcrumb, index: number) => {
		const { breadcrumbs } = this.props;

		let content: JSX.Element;

		if (index === (breadcrumbs.length - 1)) {
			content = (
				<span className={Classes.BREADCRUMB + ' ' + Classes.BREADCRUMB_CURRENT}>
					{this.renderLabel(item)}
				</span>
			);
		} else {
			content = (
				<Link target={item.target} breadcrumbs={this.sliceBreadcrumbs(index)} className={Classes.BREADCRUMB}>
					{this.renderLabel(item)}
				</Link>
			);
		}

		return (
			<li key={item.key}>
				{content}
			</li>
		);
	}

	private renderLabel = (item: IBreadcrumb) => {
		if (typeof item.label === 'object') {
			return <Label {...item.label} />;
		}
		return item.label; // plain string
	}

	private sliceBreadcrumbs = (index: number) => () => {
		const { breadcrumbs } = this.props;
		return breadcrumbs.length > 0 ? breadcrumbs.slice(0, index + 1) : [];
	}
}

const ConnectedBreadcrumbs = connect(mapStateToProps)(BreadcrumbsComponent);

/**
 * displays current breadcrumbs from state
 */

@Panel({id: "breadcrumbs", configClass: BreadcrumbsPanelConfig})
class BreadcrumbsPanel extends React.PureComponent<IPanelProps<BreadcrumbsPanelConfig>> {

	public render() {
		return <ConnectedBreadcrumbs config={this.props.config}/>;
	}
}



// WEBPACK FOOTER //
// ./src/panels/breadcrumbs/Breadcrumbs.panel.tsx